import { ReactNode } from "react";
import { ListContainer } from "./styles";

interface Props {
  children: ReactNode;
  childHover?: boolean;
  hoverColor?: string;
  lastChildBorder?: boolean;
}

export const PanelList = ({
  children,
  childHover = true,
  hoverColor,
  lastChildBorder = false,
}: Props) => {
  return (
    <ListContainer
      childHover={childHover}
      hoverColor={hoverColor}
      lastChildBorder={lastChildBorder}
    >
      {children}
    </ListContainer>
  );
};
